/* EclatDent — header : masquage au scroll, tiroir mobile, overlay recherche, badge panier */
(() => {
  if (window.__edhInit) return;
  window.__edhInit = true;

  const root = document.querySelector('[data-edh]');
  if (!root) return;

  // — Masquage à la descente, retour à la remontée + état "scrolled" —
  let lastY = window.scrollY, ticking = false;
  function onScroll() {
    ticking = false;
    const y = window.scrollY;
    root.classList.toggle('is-scrolled', y > 10);
    const drawerOpen = drawer && !drawer.hidden;
    if (!drawerOpen) {
      if (y > lastY && y > 140) root.classList.add('is-hidden');
      else root.classList.remove('is-hidden');
    }
    lastY = y;
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  // — Tiroir mobile —
  const burger = root.querySelector('[data-edh-burger]');
  const drawer = root.querySelector('[data-edh-drawer]');
  onScroll();
  function setDrawer(open) {
    if (!drawer || !burger) return;
    drawer.hidden = !open;
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    document.documentElement.classList.toggle('edh-lock', open);
    if (open) root.classList.remove('is-hidden');
  }
  if (burger && drawer) {
    burger.addEventListener('click', () => setDrawer(drawer.hidden));
    drawer.addEventListener('click', (e) => {
      if (e.target instanceof Element && e.target.closest('a')) setDrawer(false);
    });
  }

  // — Overlay recherche —
  const search = root.querySelector('[data-edh-search]');
  const searchInput = root.querySelector('[data-edh-search-input]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    document.documentElement.classList.toggle('edh-lock', open);
    if (open && searchInput) setTimeout(() => searchInput.focus(), 30);
  }
  root.querySelectorAll('[data-edh-search-open]').forEach((b) => b.addEventListener('click', () => { setDrawer(false); setSearch(true); }));
  root.querySelectorAll('[data-edh-search-close]').forEach((b) => b.addEventListener('click', () => setSearch(false)));
  if (search) search.addEventListener('click', (e) => { if (e.target === search) setSearch(false); });
  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (search && !search.hidden) setSearch(false);
    else if (drawer && !drawer.hidden) setDrawer(false);
  });

  // — Badge panier : rendu par Liquid, rafraîchi sur cart:refresh (nos ajouts AJAX) et au retour bfcache —
  const count = root.querySelector('[data-edh-count]');
  function refreshCount() {
    if (!count) return;
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      const n = cart.item_count || 0;
      count.textContent = String(n);
      count.hidden = n === 0;
      count.classList.add('pop');
      setTimeout(() => count.classList.remove('pop'), 250);
    }).catch(() => {});
  }
  document.addEventListener('cart:refresh', refreshCount);
  addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });
})();
